<app-page-wrapper [title]="pageTitle()" [loading]="this.loadingData()" [error]="state().error">

  <ng-container *ngIf="!this.loadingData()">
    @if (ownerMode()) {
      <div class="mb-5">
        <p-card>
          <div class="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
            <div class="flex flex-col gap-2">
              <span class="text-sm uppercase tracking-wide text-gray-500">
                Widok właściciela
              </span>
              <span class="text-lg font-semibold text-gray-900 dark:text-gray-50">
                Dodajesz czas pracy w imieniu wybranego użytkownika
              </span>
              <span class="text-sm text-gray-600 dark:text-gray-300">
                Aktualnie edytujesz:
                <strong>
                  {{ selectedUser()?.firstName ?? 'wybierz' }}
                  {{ selectedUser()?.lastName ?? 'użytkownika' }}
                </strong>
              </span>
            </div>

            <div class="w-full lg:w-96">
              <label for="ownerUser" class="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-200">
                Użytkownik
              </label>
              <p-select
                inputId="ownerUser"
                [options]="ownerUserOptions()"
                optionLabel="fullName"
                optionValue="id"
                [ngModel]="selectedUserId()"
                (ngModelChange)="onOwnerUserChange($event)"
                placeholder="Wybierz użytkownika"
                appendTo="body"
                styleClass="w-full"
              >
                <ng-template let-user pTemplate="item">
                  {{ user.firstName }} {{ user.lastName }}
                </ng-template>
                <ng-template let-user pTemplate="selectedItem">
                  {{ user.firstName }} {{ user.lastName }}
                </ng-template>
              </p-select>
            </div>
          </div>
        </p-card>
      </div>
    }

    <!-- jeśli nie ma danych -->
    <ng-container *ngIf="!this.loadingData() && !hasData(); else tableContent">
      <div class="flex flex-col items-center justify-center gap-3 py-10 text-center">
        <i class="pi pi-calendar-times text-6xl text-gray-400"></i>
        <span class="text-gray-700 font-semibold text-xl">
          Upsâ€¦ Tu jest pusto!
        </span>
        <span class="text-gray-600 text-lg">
          Wygląda na to, że nie masz jeszcze żadnych klientów ani projektów.
        </span>
        <span class="text-gray-500 mt-2">
          Dodaj je, aby zacząć rejestrować czas i śledzić postępy.
        </span>
        <p-button label="Dodaj projekt / klienta"
                  class="mt-4 px-4 py-2"
                  (onClick)="goToAddClient()"
                  outlined
        ></p-button>
      </div>
    </ng-container>

    <!-- jeśli są dane -->
    <ng-template #tableContent>
      <div class="mb-5">
        <p-card>
          <div class="filter-container flex flex-row items-center justify-end gap-4">
            <div class="filter-container flex flex-row items-center justify-end gap-4">
              <p-datepicker
                #datePicker
                [(ngModel)]="range"
                [firstDayOfWeek]="1"
                selectionMode="range"
                [placeholder]="'Wybierz tydzień'"
                [readonlyInput]="true"
                dateFormat="dd.mm.yy"
                (onSelect)="onDateRangeSelect($event)"
                [iconDisplay]="'input'"
                [showIcon]="true"
                inputId="icondisplay"
                [showButtonBar]="true"
                [numberOfMonths]="1"
              ></p-datepicker>
              <p-button
                icon="pi pi-chevron-left"
                variant="outlined"
                (onClick)="goToPreviousWeek()"
              ></p-button>
              <p-button
                icon="pi pi-chevron-right"
                variant="outlined"
                (onClick)="goToNextWeek()"
              ></p-button>
            </div>
          </div>
        </p-card>
      </div>

      <p-card class="h-100">
        <app-timesheet-table
          [startDate]="start()!"
          [timeEntries]="timeEntries()"
          [workItems]="workItems() ?? []"
          (rowDelete)="onRowDelete($event)"
          (cellClick)="onCellClick($event)"
        ></app-timesheet-table>
      </p-card>
    </ng-template>
  </ng-container>

</app-page-wrapper>
